<script lang="ts">
    import {createEventDispatcher} from 'svelte';
    import type {DefinedMessage, DefinedMessageType} from './types';
    import {definedMessageService} from './services';
    import LoadingDiv from './LoadingDiv.svelte';

    export let type: DefinedMessageType;

    const dispatch = createEventDispatcher();

    const definedMessagesPromise: Promise<DefinedMessage[]> = definedMessageService.getOfType(type);

    function select(definedMessage) {
        dispatch('predefined-message-selected', definedMessage.text);
    }
</script>

<div class="panel">
    {#await definedMessagesPromise}
        <LoadingDiv design="calm" />
    {:then definedMessages}
        {#each definedMessages as definedMessage (definedMessage.id)}
            <div class="defined-message-content" on:click={() => select(definedMessage)}>
                {definedMessage.text}
            </div>
        {/each}
    {/await}
</div>


<style lang="scss">
  .defined-message-content {
    background-color: rgba(0,0,0,0);
    border: 0;
    cursor: pointer;
    margin: 3px 0;
    padding: 3px 5px;
    font-size: 0.9em;

    &:hover {
      background-color: rgba(150,150,150,0.2);
      transition: all 0.5s;
    }
  }
</style>